import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import {AbstractDataProvider} from '../AbstractDataProvider';
import {AuthService} from 'src/shared/service/auth.service';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FAQComponent implements OnInit {

  @Output() close = new EventEmitter<boolean>();

  display = false;
  alertMessage: string;
  faqHtml: any;

  isExpanded = false;
  notIsLoggedIn = true;

  phone: string;
  email: string;
  companyName: string;
  companyShortName: string;
  companyWebsite: string;

  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private authService: AuthService,
    private http: HttpClient, private sanitizer: DomSanitizer,
    private router: Router) {
  }

  ngOnInit() {
    this.authService.configurationSet$.subscribe(() => {
      if (this.authService.configReady) {
        this.update();
      }
    });
    if (this.authService.configReady) {
      this.update();
    }
  }

  private update() {
    this.companyName = this.authService.wpCompanyName;
    this.companyShortName = this.authService.wpCompanyShortName;
    this.phone = this.authService.wpContactPhone;
    this.email = this.authService.wpContactEmail;
    this.companyWebsite = this.authService.wpCompanyWebsite;
    const faqFile = 'assets/' + this.authService.wpFaqFile;

    this.http.get(faqFile, {responseType: 'text'})
      .subscribe(data => {
        data = data.split('{{servicePhone}}').join(this.phone);
        data = data.split('{{email}}').join(this.email);
        data = data.split('{{companyName}}').join(this.companyName);
        data = data.split('{{companyShortName}}').join(this.companyShortName);
        data = data.split('{{companyWebsite}}').join(this.companyWebsite);
        this.faqHtml = this.sanitizer.bypassSecurityTrustHtml(data);
      }, error => {

      });

    this.notIsLoggedIn = !this.authService.isAuthenticated;

    this.router.events.subscribe(() => {
      if (event instanceof NavigationEnd) {
        this.notIsLoggedIn = !this.authService.isAuthenticated;
      }
    });

    window['scrollToElement'] = (id) => {
      const el = document.getElementById(id);

      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    };
  }
}
